export const GET_COMPANY_BY_SLUG_REQUEST = "GET_COMPANY_BY_SLUG_REQUEST";
export const GET_COMPANY_BY_SLUG_SUCCESS = "GET_COMPANY_BY_SLUG_SUCCESS";
export const GET_COMPANY_BY_SLUG_FAIL = "GET_COMPANY_BY_SLUG_FAIL";

